export default __webpack_public_path__ + "static/media/logo-bank-7.a2e4d44a.png";